import { MapPin } from "lucide-react";

const merlo = [
  { name: "Merlo (Centro)", desc: "Sede central — Leandro N. Alem 734" },
  { name: "San Antonio de Padua", desc: "Cobertura FTTH" },
  { name: "Libertad", desc: "Cobertura FTTH" },
  { name: "Mariano Acosta", desc: "Cobertura FTTH" },
  { name: "Pontevedra", desc: "Cobertura FTTH" },
];

const otras = [
  { name: "Ituzaingó", desc: "Cobertura FTTH" },
  { name: "Baradero", desc: "Cobertura FTTH en toda la ciudad" },
];

const stats = [
  { v: "6", l: "Localidades" },
  { v: "+10.000", l: "Clientes" },
  { v: "99.9%", l: "Uptime" },
  { v: "< 5ms", l: "Latencia" },
];

const Cobertura = () => (
  <section
    id="cobertura"
    className="relative overflow-hidden border-y border-slate-100 bg-gradient-to-b from-white via-sky-50/40 to-white py-14"
  >
    <div className="pointer-events-none absolute inset-0 opacity-[0.5]">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "radial-gradient(#e0f2fe 1px, transparent 1px), radial-gradient(#fce7f3 1px, transparent 1px)",
          backgroundSize: "36px 36px, 36px 36px",
          backgroundPosition: "0 0, 18px 18px",
        }}
      />
    </div>

    <div className="relative mx-auto max-w-6xl px-6">
      <div className="mb-12 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-sky-500">
          Cobertura
        </p>
        <h2 className="mt-3 text-3xl font-black text-slate-900 md:text-5xl">
          Zona Oeste y más
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-slate-600">
          Nuestra red FTTH cubre la Zona Oeste del Gran Buenos Aires y sigue
          creciendo. Consultá si tu dirección está en zona.
        </p>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-3xl border border-slate-100 bg-white p-7 shadow-sm">
          <h3 className="text-xl font-bold text-slate-900">Partido de Merlo</h3>
          <ul className="mt-5 divide-y divide-slate-100">
            {merlo.map((m) => (
              <li key={m.name} className="flex items-start gap-3 py-3 text-sm">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-pink-500" />
                <div>
                  <p className="font-semibold text-slate-900">{m.name}</p>
                  <p className="text-slate-500">{m.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-3xl border border-slate-100 bg-white p-7 shadow-sm">
          <h3 className="text-xl font-bold text-slate-900">
            Otras localidades
          </h3>
          <ul className="mt-5 divide-y divide-slate-100">
            {otras.map((m) => (
              <li key={m.name} className="flex items-start gap-3 py-3 text-sm">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-sky-500" />
                <div>
                  <p className="font-semibold text-slate-900">{m.name}</p>
                  <p className="text-slate-500">{m.desc}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-6 grid grid-cols-2 gap-3">
            {stats.map((s) => (
              <div
                key={s.l}
                className="rounded-2xl bg-gradient-to-br from-pink-50 to-sky-50 p-4"
              >
                <p className="text-2xl font-black text-slate-900">{s.v}</p>
                <p className="mt-1 text-[11px] uppercase tracking-widest text-slate-500">
                  {s.l}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Cobertura;
